angular.module('zc.core')

/**
 * httpOnce makes sure that no multiple instances of same requests are simultaneously.
 * For example if a page has 10 components which all ask for user and project,
 * there would normally be 10 requests for user and project simultaneously.
 *
 * With httpOnce, subsequent exactly same requests get the first request's
 * promise, so only one request is sent.
 *
 * This is bit modified from:
 * http://stackoverflow.com/questions/32958046/preventing-multiple-http-requests-in-angular-is-there-a-better-way
 */
  .factory('$httpOnce', $httpOnce);

$httpOnce.$inject = ['$cacheFactory', '$http'];
function $httpOnce($cacheFactory, $http) {
  // TODO: this is in zc.core, so cannot use babel+es6 yet
  let cache = $cacheFactory('$httpOnce');

  let service = function(params, options) {
    // TODO: this is in zc.core, so cannot use babel+es6 yet
    let cacheKey = angular.toJson(params);

    // return the promise from cache if same request is already in progress
    return cache.get(cacheKey) || cache.put(cacheKey, $http(params, options))
      .then(function(response) {
        return response;
      }).finally(function() {
        // clear cache once we are done
        cache.remove(cacheKey);
      });
  };

  return service;
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/$http_once.service.js